if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class StickyAtc extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.dataset.sectionId;
        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.button = this.querySelector('.sticky-atc__submit');
        this.label = this.querySelector('.sticky-atc__label');
        this.priceTarget = this.querySelector('.sticky-atc__price');
      }

      connectedCallback() {
        // The inline ATC button we watch to decide when to reveal the bar.
        this.observed = document.getElementById(this.dataset.observeId);
        if (!this.observed) return;

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(
            (entries) => {
              // Reveal only once the inline ATC has scrolled out of view, and only on mobile.
              const inlineVisible = entries[0].isIntersecting;
              this.toggleVisible(!inlineVisible && this.mobileQuery.matches);
            },
            { rootMargin: '0px', threshold: 0 }
          );
          this.observer.observe(this.observed);
        }

        // Re-evaluate when crossing the desktop/mobile breakpoint.
        this.onBreakpointChange = () => {
          if (!this.mobileQuery.matches) this.toggleVisible(false);
        };
        this.mobileQuery.addEventListener('change', this.onBreakpointChange);

        // READ-ONLY sync with Dawn's variant change. Never selects variants or submits.
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (event?.data?.sectionId !== this.sectionId) return;
            this.syncFromHtml(event.data.html);
          });
        }
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.variantChangeUnsubscriber?.();
        this.mobileQuery.removeEventListener('change', this.onBreakpointChange);
      }

      toggleVisible(show) {
        this.toggleAttribute('hidden', !show);
      }

      // Mirror price + disabled/label from the freshly-fetched product HTML, matching
      // exactly what product-info.js applies to the inline ATC.
      syncFromHtml(html) {
        if (!html) return;

        const newPrice = html.getElementById(this.dataset.priceId);
        if (newPrice && this.priceTarget) this.priceTarget.innerHTML = newPrice.innerHTML;

        const newButton = html.getElementById(this.dataset.observeId);
        if (newButton && this.button) {
          const disabled = newButton.hasAttribute('disabled');
          this.button.disabled = disabled;
          const text = newButton.querySelector('span')?.textContent;
          if (text && this.label) this.label.textContent = text.trim();
        }
      }
    }
  );
}
